import React, { useCallback, useEffect, useRef, useState } from "react";
import { rootReducerType } from "redux/combineReducers";
import { useSelector } from "react-redux";
import { Tabs, DatePicker } from "antd";
import { chartTabPanelsDetails, OneWeekInMilliseconds } from "common/constants";
import moment from "moment";
import { decodeJWT } from "common/functions";
import TransEnergy from "../Chart/TransEnergy";
// import Utilization from "../Chart/Utilization";
import Transaction from "components/Transaction/Transaction"
import Utilization from "components/Utilization/Utilization"
import Revenue from "components/Revenue/Revenue";
// import Reductions from "../Chart/Reductions";
import "./Details.less";
import { emailToUsername } from "common/utils";
import Power from "components/power/power";

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

const getTabPanels = (target: string) => {
  if (target === "station")
    return chartTabPanelsDetails.map((tabPanel) => (
      <TabPane tab={tabPanel.name} tabKey={tabPanel.key} key={tabPanel.key} />
    ));
  else if (target === "all")
    return chartTabPanelsDetails.slice(0, -1).map((tabPanel) => (
      <TabPane tab={tabPanel.name} tabKey={tabPanel.key} key={tabPanel.key} />
    ));
};

type Props = {
  locationId?: string;
  width: number;
  shouldRefresh?: boolean
};

const Details: React.FC<Props> = ({ locationId, width, shouldRefresh }) => {
  const { isLoggedIn } = useSelector(
    (state: rootReducerType) => state.authenticationReducer
  );

  const { stationId } = useSelector(
    (state: rootReducerType) => state.stationIdReducer
  );

  const [params, setParams] = useState({
    // userName: emailToUsername(decodeJWT(isLoggedIn).email),
    startDate: moment(
      new Date(Date.now() - OneWeekInMilliseconds)
        .toISOString(),
      "YYYY-MM-DD"
    ).startOf("day").format('YYYY-MM-DDTHH:mm:ss'),
    endDate: moment().endOf("day").format('YYYY-MM-DDTHH:mm:ss'),
    // locationId,
  });

  const [tabIndex, setTabIndex] = useState<string>("1");

  const detailsCharts = useRef(null)

  const handleChangeTab = (key: string) => {
    const panelDetails = chartTabPanelsDetails.find(
      (tabPanel) => tabPanel.key === key
    );
    if (panelDetails) {
      setTabIndex(key);
    }
  };

  const [isOpenRangePicker, setIsOpenRangePicker] = useState<boolean>(false);
  const [newDatesUpdate, setNewDatesUpdate] = useState<any>(null);

  const onChange = (newDates) => {
    setNewDatesUpdate(newDates)
  };

  useEffect(() => {
    if (!isOpenRangePicker && newDatesUpdate) {
      const newStartDate = moment(newDatesUpdate[0]).startOf("day").format('YYYY-MM-DDTHH:mm:ss').toString();
      const newEndDate = moment(newDatesUpdate[1]).endOf("day").format('YYYY-MM-DDTHH:mm:ss').toString();
      setParams(prevParams => ({
        ...prevParams,
        startDate: prevParams.startDate === newStartDate ? prevParams.startDate : newStartDate,
        endDate: prevParams.endDate === newEndDate ? prevParams.endDate : newEndDate
      }));
    }
  }, [isOpenRangePicker])

  useEffect(() => {
    if (!stationId) {
      setTabIndex("1")
    }
  }, [stationId])

  // const getChart = useCallback(() => {

  //   return !locationId ? (tabIndex === "1" ? (
  //     <TransEnergy params={params} shouldRefresh={shouldRefresh} />
  //   ) : tabIndex === "2" ? (
  //     <Utilization params={params} shouldRefresh={shouldRefresh} />
  //   ) : null)
  //     : (tabIndex === "1" ? (
  //       <TransEnergy params={params} shouldRefresh={shouldRefresh} />
  //     ) : tabIndex === "2" ? (
  //       <Utilization params={params} shouldRefresh={shouldRefresh} />
  //     ) : tabIndex === "3" ? (
  //       <Power params={params} shouldRefresh={shouldRefresh} />
  //     ) : null);
  // }, [params.userName, params.endDate, params.locationId, tabIndex]);


  const getChart = () => {
    return tabIndex === "1" ? <Transaction params={params} /> : (
      tabIndex === "2" ? <Utilization params={params} /> : (
        tabIndex === "3" ? <Revenue params={params} /> : (
          tabIndex === "4" ? <Power params={params} /> : <Transaction params={params} />
        ))
    )
  }

  const tabClick = (tabIndex: string) => {
    setTabIndex(tabIndex)
  }

  const onRangePickerChange = (open: boolean) => {
    setIsOpenRangePicker(open)
  }

  return (
    // <section className="details-container">
    //   {width > 768 ? (
    //     <div className="details-header">
    //       <Tabs
    //         style={{ paddingTop: 5 }}
    //         tabPosition="top"
    //         onChange={handleChangeTab}
    //         tabIndex={Number(tabIndex)}
    //         tabBarStyle={{ marginTop: 0 }}
    //         size="small"
    //       >
    //         { locationId ? getTabPanels("station") : getTabPanels("all")}
    //       </Tabs>
    //       <RangePicker
    //         style={{ width: "30%", border: "0" }}
    //         format="YYYY-MM-DD"
    //         suffixIcon
    //         defaultValue={[
    //           moment(
    //             new Date(Date.now() - OneWeekInMilliseconds)
    //               .toISOString()
    //               .slice(0, 10),
    //             "YYYY-MM-DD"
    //           ),
    //           moment(new Date().toISOString().slice(0, 10), "YYYY-MM-DD"),
    //         ]}
    //         onChange={(value, dateString) => onChange(dateString)}
    //       />
    //     </div>
    //   ) : (
    //     <>
    //       <Tabs
    //         activeKey={tabIndex}
    //         tabPosition="bottom"
    //         onChange={handleChangeTab}
    //         tabIndex={Number(tabIndex)}
    //         tabBarStyle={{ marginTop: 0 }}
    //         destroyInactiveTabPane
    //         style={{ height: "10%" }}
    //       >
    //         { locationId ? getTabPanels("station") : getTabPanels("all")}
    //       </Tabs>
    //       <RangePicker
    //         format="YYYY-MM-DD"
    //         suffixIcon
    //         style={{
    //           width: "250px",
    //           alignSelf: "center",
    //           height: "5%",
    //           border: "0",
    //         }}
    //         defaultValue={[
    //           moment(
    //             new Date(Date.now() - OneWeekInMilliseconds)
    //               .toISOString()
    //               .slice(0, 10),
    //             "YYYY-MM-DD"
    //           ),
    //           moment(new Date().toISOString().slice(0, 10), "YYYY-MM-DD"),
    //         ]}
    //         onChange={onChange}
    //       />
    //     </>
    //   )}
    //   {/* <div className="details-chart">
    // 		{getChart()}
    //   </div> */}
    // </section>
    <section className="details-container">
      <div className="details-title">
        <div className="details-title-left" style={{
          color: tabIndex == "1" ? '#426CB4' : '',
          borderBottom: tabIndex == "1" ? '1px solid #426CB4' : 'none'
        }} onClick={() => tabClick("1")}>Sessions & energy</div>
        <div className="details-title-center"
          style={{ color: tabIndex == "2" ? '#426CB4' : '', borderBottom: tabIndex == "2" ? '1px solid #426CB4' : 'none' }}
          onClick={() => tabClick("2")}>Utilization</div>
        <div className="details-title-center"
          style={{ color: tabIndex == "3" ? '#426CB4' : '', borderBottom: tabIndex == "3" ? '1px solid #426CB4' : 'none' }}
          onClick={() => tabClick("3")}>Revenue</div>
        {stationId ? <div className="details-title-center"
          style={{ color: tabIndex == "4" ? '#426CB4' : '', borderBottom: tabIndex == "4" ? '1px solid #426CB4' : 'none' }}
          onClick={() => tabClick("4")}>power</div> : <></>}
        <div className="details-title-right">
          <RangePicker
            style={{ width: "100%", border: "0" }}
            format="YYYY-MM-DD"
            suffixIcon
            defaultValue={[
              moment(
                new Date(Date.now() - OneWeekInMilliseconds)
                  .toISOString()
                  .slice(0, 10),
                "YYYY-MM-DD"
              ),
              moment(new Date().toISOString().slice(0, 10), "YYYY-MM-DD"),
            ]}
            onChange={(value, dateString) => onChange(dateString)}
            open={isOpenRangePicker}
            onOpenChange={onRangePickerChange}
          />
        </div>
      </div>
      {getChart()}
    </section>
  );
};

export default Details;
